import * as React from 'react'

import { inject, observer } from 'mobx-react'

import FileFullscreenPreview from '~/client/src/shared/components/FileFullscreenPreview/FileFullscreenPreview'
import { SHOW_FULLSCREEN_PREVIEW } from '~/client/src/shared/stores/EventStore/eventConstants'
import EventContext from '~/client/src/shared/stores/EventStore/EventContext'
import { notifyOverlayOpen } from '~/client/src/shared/utils/overlayNotifier'

import MobileEventStore from '../../stores/EventStore/MobileEvents.store'
import MobileFullscreenPreviewStore from './MobileFullscreenPreview.store'

import './MobileFullscreenPreview.scss'

interface IMobileFullScreenPreviewProps {
  eventsStore?: MobileEventStore
}

@inject('eventsStore')
@observer
export default class MobileFullScreenPreview extends React.Component<IMobileFullScreenPreviewProps> {
  private readonly store: MobileFullscreenPreviewStore
  private readonly clearPostEventCallback: () => void
  private closeOverlay: (() => void) | null = null

  public constructor(props: IMobileFullScreenPreviewProps) {
    super(props)

    this.store = new MobileFullscreenPreviewStore()
    this.clearPostEventCallback = props.eventsStore.addPostEventCallback(
      this.onShowFullscreenRequest,
    )
  }

  public componentDidUpdate() {
    const { shouldShowFullscreenImagePreview } = this.store

    if (shouldShowFullscreenImagePreview && !this.closeOverlay) {
      this.closeOverlay = notifyOverlayOpen()
    } else if (!shouldShowFullscreenImagePreview && this.closeOverlay) {
      this.closeOverlay()
      this.closeOverlay = null
    }
  }

  public componentWillUnmount() {
    this.closeOverlay?.()
    if (this.clearPostEventCallback) {
      this.clearPostEventCallback()
    }
  }

  public render() {
    const {
      hideFullscreenPreview,
      shouldShowFullscreenImagePreview,
      files,
      fileIndex,
    } = this.store

    if (!shouldShowFullscreenImagePreview) {
      return <div />
    }

    return (
      <div className="fullscreen">
        <div className="full-height">
          <FileFullscreenPreview
            files={files}
            fileIndex={fileIndex}
            onClose={hideFullscreenPreview}
            isMobile={true}
          />
        </div>
      </div>
    )
  }

  private onShowFullscreenRequest = (eventContext: EventContext) => {
    const [eventType, files, fileIndex] = eventContext.event
    if (eventType === SHOW_FULLSCREEN_PREVIEW) {
      this.store.showFullscreenPreview(files, fileIndex)
    }
  }
}
